import "./__timeago.scss"

